import { useState } from 'react';
import { updatePassword, signOut } from '../supabase';
import { MarcoAcceso, CampoClave } from './AccesoMarco';
import { CLAVE_MIN, REGLA_CLAVE, validarClave, traducirErrorAuth } from '../utils/claveAuth';

// ═══════════════════════════════════════════════════════════════════════════════
// FORCE CHANGE (Fase 3) — cambio OBLIGATORIO de clave temporal en el primer login.
// Se muestra cuando hay sesión y user_metadata.must_change_password === true.
// updateUser({ password, data:{ must_change_password:false } }) cambia la clave y
// limpia el flag en una sola llamada → al refrescar el metadata, App.js deja pasar.
// ═══════════════════════════════════════════════════════════════════════════════

export default function ForceChangePassword({ userName, onDone }) {
  const [p1, setP1]   = useState('');
  const [p2, setP2]   = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr('');
    const falta = validarClave(p1);
    if (falta)            { setErr(falta); return; }
    if (p1 !== p2)        { setErr('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try {
      const { error } = await updatePassword(p1);   // limpia must_change_password
      if (error) { setErr(traducirErrorAuth(error, 'No se pudo actualizar la contraseña. Intenta de nuevo.')); setBusy(false); return; }
      onDone?.();   // App.js recomputa mustChange tras USER_UPDATED
    } catch {
      setErr('Error de conexión. Intenta de nuevo.');
    }
    setBusy(false);
  };

  const onKey = (e) => { if (e.key === 'Enter') submit(); };

  return (
    <MarcoAcceso>
      <h2 className="lg-h">Crea tu contraseña</h2>
      <p className="lg-sub">
        {userName ? <><b>{userName}</b>, por </> : 'Por '}seguridad debes cambiar tu contraseña temporal antes de continuar. {REGLA_CLAVE}
      </p>

      <CampoClave id="fc-p1" label="Nueva contraseña" show={show} onToggle={()=>setShow(!show)}
        autoComplete="new-password" value={p1} onChange={e=>{setP1(e.target.value);setErr('');}}
        onKeyDown={onKey} placeholder={`Mínimo ${CLAVE_MIN} caracteres, con letras y números`} autoFocus />
      <CampoClave id="fc-p2" label="Confirmar contraseña" show={show} conBoton={false}
        autoComplete="new-password" value={p2} onChange={e=>{setP2(e.target.value);setErr('');}}
        onKeyDown={onKey} placeholder="Repite la contraseña" />

      {err && <div className="lg-msg error">{err}</div>}

      <button className="lg-btn" onClick={submit} disabled={busy}>
        {busy ? 'Guardando…' : 'Guardar y continuar'}
      </button>

      <div className="lg-centro">
        <button className="lg-link" onClick={async()=>{ await signOut(); onDone?.(); }}>
          Cerrar sesión
        </button>
      </div>
    </MarcoAcceso>
  );
}
